import React from 'react';

const KinTheme = {
  headerLogo: {
    src: '/themes/theme/kin/logo.png',
    alt: 'Kin Community',
  },
  darkLogo: {
    src: '/themes/theme/kin/logo-dark.png',
    alt: 'Kin Community',
  },
  headerStyle: {
    backgroundColor: '#0d1b2d',
    borderBottom: '2px solid #000',
  },
  linkStyle: {
    color: '#FFF',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'Kin Community',
  isLightOnDark: true,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <img height="120" src="/themes/theme/kin/logo-dark.png" alt="Kin" />
      <br />
      <br />
      <hr />
      <h2>Kin Community Influencers</h2>
    </div>
  ),
  shareSite: 'https://kin.dyzio.co',
};

export default KinTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/kin.js
 **/